import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import RefreshIcon from '@material-ui/icons/Autorenew';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { TABLE_HEADER_COLOR } from '../../_config/consts';
import { getColorFromThemeName } from '../../_config/utils';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import MDTablePaginationActions from '../MDTable/MDTablePaginationActions.jsx';

const styles = theme => ({
  table: {
    overflow: 'scroll',
  },
  tableColumnText: {
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
  disabledInput: {
    display: 'none',
  },
  rowSelected: {
    backgroundColor: 'aliceblue !important',
    color: 'aliceblue !important',
  },
  rowHovered: {
    cursor: 'pointer',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
    minHeight: 60,
  },
  paginationText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#3f3f3f',
  },
});

@connect((state) => ({ 
  viewLoading: state.utils.viewLoading, 
  mks: state.mks, 
  themeName: state.settings.items.theme.data.themeName 
}))
class MksCylindersTableView extends React.Component {

  render() {
    const {
      classes,
      viewLoading,
      themeName,
      mks,
      cylindersData: propsCylindersData,
      onRefreshCylinders,
      onFetchCylindersOnPage,
      onSelectCylinder,
    } = this.props;

    // Use cylindersData from props if provided, otherwise use from Redux state
    const cylindersData = propsCylindersData || (mks && mks.cylinders && mks.cylinders.data ? mks.cylinders.data : {});
    const cylindersContent = cylindersData && cylindersData.content ? cylindersData.content : [];
    const pagination = cylindersData && !_.isEmpty(cylindersData) ? _.omit(cylindersData, 'content') : {};
    const { number: currentPage = 0, size = 0, totalPages = 0, totalElements = 0 } = pagination;

    const headerColor = getColorFromThemeName(themeName);
    
    return (
      <div className="list-view details-section" style={{ top: 150, paddingBottom: 140, width: '87%' }}>
        <div>
          {!_.isEmpty(cylindersContent) ?
            <Card style={{ overflow: 'scroll' }} elevation={4}>
              <Table size="small" className={classes.table}>
                <TableHead>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TableCell colSpan={4}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <h3 className={classes.tableColumnText} style={{ color: '#3f3f3f', marginTop: 15, marginBottom: 15 }}>
                          <Entity entity="mksCylinders" />
                        </h3>
                        <IconButton onClick={() => onRefreshCylinders()} style={{ marginLeft: 10, marginTop: 5 }}>
                          <RefreshIcon style={{ color: '#3f3f3f', fontSize: 25 }} />
                        </IconButton>
                      </div>
                    </TableCell>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="mksCylindersTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchCylindersOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          iconColor="#3f3f3f"
                          page={currentPage}
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchCylindersOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                  <TableRow style={{ backgroundColor: 'white' }}>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="id" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="externalId" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="doorName" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="marking" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="type" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="insideLength" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="outsideLength" /></h4></TableCell>
                    <TableCell><h4 className={classes.tableColumnText}><Entity entity="quantity" /></h4></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_.map(cylindersContent, (cylinder) => {
                    return (
                      <TableRow
                        key={cylinder.id}
                        className={classes.row}
                        hover
                        classes={{
                          selected: classes.rowSelected,
                          hover: classes.rowHovered,
                        }}
                        onClick={event => onSelectCylinder && onSelectCylinder(cylinder)}
                      >
                        <TableCell>
                          <h5 style={{ fontWeight: 'bold', fontSize: 14 }}>{cylinder.id || '---'}</h5>
                        </TableCell>
                        <TableCell>
                          <h5 style={{ fontSize: 14 }}>{cylinder.externalId || '---'}</h5>
                        </TableCell>
                        <TableCell>
                          <h5 style={{ fontSize: 14 }}>{cylinder.doorName || '---'}</h5>
                        </TableCell>
                        <TableCell>
                          <h5 style={{ fontSize: 14 }}>{cylinder.marking || '---'}</h5>
                        </TableCell>
                        <TableCell>
                          <h5 style={{ fontSize: 14 }}>{cylinder.type || '---'}</h5>
                        </TableCell>
                        <TableCell>
                          <h5 style={{ fontSize: 14 }}>{cylinder.insideLength || '---'}</h5>
                        </TableCell>
                        <TableCell>
                          <h5 style={{ fontSize: 14 }}>{cylinder.outsideLength || '---'}</h5>
                        </TableCell>
                        <TableCell>
                          <h5 style={{ fontSize: 14 }}>{cylinder.quantity || '---'}</h5>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  <TableRow style={{ backgroundColor: TABLE_HEADER_COLOR }}>
                    <TablePagination
                      colSpan={0}
                      count={!_.isUndefined(totalElements) ? totalElements : 0}
                      rowsPerPage={!_.isUndefined(size) ? size : 0}
                      page={!_.isUndefined(currentPage) ? currentPage : 0}
                      labelRowsPerPage=" "
                      classes={{
                        input: classes.disabledInput,
                      }}
                      labelDisplayedRows={({ from, to, count }) => (
                        <h4 className={classes.paginationText}>
                          <Entity
                            key={`${from}-${totalPages}-${count}`}
                            entity="mksCylindersTablePagination"
                            data={{
                              currentPage: !_.isUndefined(currentPage) ? currentPage + 1 : 0,
                              totalPages: !_.isUndefined(totalPages) ? totalPages : 0,
                              count: !_.isUndefined(count) ? count : 0,
                            }}
                          />
                        </h4>
                      )}
                      onChangePage={(event, page) => onFetchCylindersOnPage(page)}
                      ActionsComponent={() => (
                        <MDTablePaginationActions
                          count={totalElements}
                          page={currentPage}
                          iconColor="#3f3f3f"
                          lastPage={totalPages - 1}
                          rowsPerPage={size}
                          onChangePage={(event, page) => onFetchCylindersOnPage(page)}
                        />
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Card>
            : (
              <div>
                {!viewLoading ? (
                  <EmptyView
                    title="noMksCylinders"
                    subtitle="noMksCylindersSubtitle"
                    iconName="icon-simple-line-icons-lock"
                  />
                ) : <ListLoadingView />}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(MksCylindersTableView);

